<template>
  <v-container>
    <AchievementsProgressLinear></AchievementsProgressLinear>
    <v-spacer></v-spacer>
    <GenericChecklist @complete="complete" @uncomplete="uncomplete" :headers="[{text:'completed', value:'completed'},{text:'achievement', value:'name'},{text:'description', value:'description'}]" :items="filtered" :itemKey="'id'"></GenericChecklist>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import GenericChecklist from '@/components/GenericChecklist'
import AchievementsProgressLinear from "@/components/AchievementsProgressLinear";


export default {
  name: "Achievements",
  components: { AchievementsProgressLinear, GenericChecklist },
  computed: {
    ...mapGetters("entities/achievements",["filtered"])
  },
  methods: {
    ...mapActions("entities/achievements", ["complete", "uncomplete"]),
  },
};
</script>
